import UpdateNotificationOverlay from "./UpdateNotificationOverlay";

export default UpdateNotificationOverlay;
